import { Component, Input } from '@angular/core';
import { IDocumentReadReceiptSummary } from 'src/app/document-user/models/document.model';

@Component({
  selector: 'app-document-overview-template',
  templateUrl: './document-overview-template.component.html',
  styleUrls: ['./document-overview-template.component.scss'],
  standalone: false,
})
export class DocumentOverviewTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  getReadReceiptSummaryLabel(element: any): string | null {
    const summary = this.getReadReceiptSummary(element);
    const readCount = summary?.readCount;
    const requiredCount = summary?.requiredCount;

    if (readCount === null || readCount === undefined) {
      return null;
    }

    if (requiredCount === null || requiredCount === undefined) {
      return null;
    }

    return `${readCount}/${requiredCount}`;
  }

  getReadReceiptSummaryStatusClass(element: any): 'ok' | 'expiring' | 'expired' {
    const summary = this.getReadReceiptSummary(element);
    const readCount = summary?.readCount ?? 0;
    const requiredCount = summary?.requiredCount ?? 0;

    if (requiredCount === 0 || readCount >= requiredCount) {
      return 'ok';
    }

    if (readCount / requiredCount >= 0.5) {
      return 'expiring';
    }

    return 'expired';
  }

  private getReadReceiptSummary(element: any): IDocumentReadReceiptSummary | null {
    return element?.readReceiptSummary ?? null;
  }

  private static readonly revisionCommentTooltipMaxChars = 350;

  getRevisionCommentPreview(comment: unknown): string {
    const text = comment == null ? '' : String(comment).trim();
    if (!text) {
      return '';
    }
    const words = text.split(/\s+/);
    if (words.length <= 6) {
      return text;
    }
    return `${words.slice(0, 6).join(' ')}…`;
  }

  getRevisionCommentTooltipText(comment: unknown): string {
    const text = comment == null ? '' : String(comment).trim();
    if (!text) {
      return '';
    }
    const max = DocumentOverviewTemplateComponent.revisionCommentTooltipMaxChars;
    if (text.length <= max) {
      return text;
    }
    return `${text.slice(0, max)}...`;
  }

  revisionCommentTooltipEnabled(comment: unknown): boolean {
    const text = comment == null ? '' : String(comment).trim();
    if (!text) {
      return false;
    }
    return text.split(/\s+/).length > 6;
  }
}
